import script from "./generate.vue?vue&type=script&setup=true&lang=js"
export * from "./generate.vue?vue&type=script&setup=true&lang=js"

import "./generate.vue?vue&type=style&index=0&id=48e3cfe7&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e3cfe7"]])

export default __exports__